import { Graph } from '@antv/x6'
import { PortTypes } from '../../constant'

export function pointRotate(point: PositionLike, center: PositionLike, angle = 0) {
  const { x, y } = point
  const { x: cx, y: cy } = center
  const radians = (Math.PI / 180) * angle
  const cos = Math.cos(radians)
  const sin = Math.sin(radians)
  const nx = cos * (x - cx) + sin * (y - cy) + cx
  const ny = cos * (y - cy) + sin * (x - cx) + cy

  return {
    x: nx,
    y: ny
  }
}


Graph.registerPortLayout(PortTypes.SvgNozzlePort, (portsPositionArgs, bbox) => {
  return portsPositionArgs.map((args) => {
    const { width, height } = bbox
    const { width: fW, x, y, angle } = args
    const portDx = x * width + fW
    const portDy = y * height
    const rotatePort = pointRotate({ x: portDx, y: portDy }, { x: x * width, y: y * height }, 360 - angle)
    return {
      position: {
        x: rotatePort.x,
        y: rotatePort.y
      },
      angle: 0
    }
  })
})
